var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.344 5V12.3125C14.344 12.5363 14.2551 12.7509 14.0968 12.9091C13.9386 13.0674 13.724 13.1562 13.5002 13.1562C13.2764 13.1562 13.0618 13.0674 12.9036 12.9091C12.7454 12.7509 12.6565 12.5363 12.6565 12.3125V7.03906L5.09717 14.597C4.93866 14.7555 4.72368 14.8445 4.49951 14.8445C4.27535 14.8445 4.06036 14.7555 3.90185 14.597C3.74335 14.4384 3.6543 14.2235 3.6543 13.9993C3.6543 13.7751 3.74335 13.5601 3.90185 13.4016L11.4612 5.84375H6.18771C5.96394 5.84375 5.74933 5.75486 5.59109 5.59662C5.43286 5.43839 5.34396 5.22378 5.34396 5C5.34396 4.77622 5.43286 4.56161 5.59109 4.40338C5.74933 4.24514 5.96394 4.15625 6.18771 4.15625H13.5002C13.724 4.15625 13.9386 4.24514 14.0968 4.40338C14.2551 4.56161 14.344 4.77622 14.344 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsArrow);
export default __webpack_public_path__ + "static/media/detailsArrow.e46209094075820724e781d06faeadec.svg";
export { ForwardRef as ReactComponent };